import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { RevealLine, Reveal } from "../lib/motion";
import { IMG } from "../data";

const PILLARS = [
  { title: "Vision", body: "Anticipare il futuro dei board: AI, dati e rischio come leve di crescita." },
  { title: "Values", body: "Integrità, indipendenza e rigore metodologico in ogni consulenza." },
  { title: "Legacy", body: "Costruire un'eredità imprenditoriale." },
];

export const Vision = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-15%", "15%"]);

  return (
    <section id="vision" ref={ref} data-testid="vision-section" className="relative min-h-[90vh] flex items-center overflow-hidden text-white">
      <motion.img style={{ y, scale: 1.25 }} src={IMG.mountains} alt="Vision Values Legacy"
        className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#2b2620]/70 via-[#2b2620]/45 to-[#2b2620]/85" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-12 py-28 w-full">
        <div className="overline !text-[var(--gold)] mb-6">Manifesto</div>
        <h2 className="font-serif text-5xl sm:text-6xl xl:text-7xl leading-[0.95] max-w-4xl">
          <RevealLine>Vision. Values.</RevealLine>
          <RevealLine delay={0.1} className="italic text-[var(--gold)]">Legacy.</RevealLine>
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/15 border border-white/15 max-w-4xl">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1} className="bg-[#2b2620]/40 backdrop-blur-sm p-8">
              <h3 className="font-serif text-2xl mb-2 text-[var(--gold)]">{p.title}</h3>
              <p className="text-white/80 text-sm leading-relaxed">{p.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
